<template>
  <div class="hot">
    <AppNavBar title="营养专题" :options="options"></AppNavBar>
    <van-pull-refresh class="refresh" v-model="refreshing" @refresh="onRefresh">
      <img
        class="bg"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-08/27c7e653da880716773eaf8c538e4c68_wh=1504_880.webp"
        alt=""
      />
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="container">
          <div class="list">
            <div
              class="list-item"
              v-for="(item, index) in list"
              :key="index"
              @click="bindClick(item)"
            >
              <div class="item-icon">
                <img class="icon" :src="item.cover_picture" alt="" />
              </div>
              <div class="item-right">
                <div class="item-title">{{ item.title }}</div>
                <div class="i-r-bottom">
                  <div class="item-read">
                    <img
                      class="read-icon"
                      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/677c39cc0dad72365d055bc70705ff2c.png"
                      alt=""
                    />
                    {{ item.read_num | filterRead }} 阅读
                  </div>
                  <div class="item-time"></div>
                  <div class="item-preview"
                    ><span>查看</span><span class="iconfont icon-you"></span
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import AppNavBar from '@/components/app/nav-bar/index.vue'
export default {
  components: {
    AppNavBar
  },
  data() {
    return {
      options: {
        barBackgroundColor: 'transparent'
      },
      refreshing: false,
      loading: false,
      finished: false,
      page: 1,
      list: []
    }
  },
  filters: {
    filterRead(num) {
      num = num >= 0 ? +num : 0
      if (num < 10000) {
        return num
      } else if (num <= 9990000) {
        return parseFloat((num / 10000).toFixed(1)) + 'w'
      } else {
        return '999w+'
      }
    }
  },
  mounted() {
    this.addScroll()
  },
  beforeDestroy() {
    this.removeScroll()
  },
  methods: {
    onRefresh() {
      this.finished = false
      this.page = 1
      this.onLoad(true)
    },
    onLoad(cover) {
      let params = {
        data_category: 2, //1表示btw营养热点，2表示健萌营养热点
        pagenum: 10,
        page: this.page
      }
      this.$http
        .getApp('api/v1/nutritionHotspot/index', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let list = (res.data && res.data.data) || []
            if (list && list.length) {
              this.list = cover ? list : this.list.concat(list)
              this.page++
            } else {
              this.finished = true
            }
          } else {
            this.$toast(res.msg)
            this.finished = true
          }
        })
        .catch(() => {
          this.finished = true
        })
        .finally(() => {
          this.refreshing = false
          this.loading = false
        })
    },
    bindScroll(e) {
      let maxHeight = 100
      var scroll = document.documentElement.scrollTop || document.body.scrollTop
      if (scroll < maxHeight) {
        scroll = scroll < 0 ? 0 : scroll
        this.options.barBackgroundColor =
          'rgba(255,255,255,' + (scroll / maxHeight).toFixed(2) + ')'
      } else {
        this.options.barBackgroundColor = 'rgba(255,255,255,1)'
      }
    },
    addScroll() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScroll() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindClick(item) {
      let url =
        '/web?url=' +
        encodeURIComponent(item.jump_url) +
        '&title=' +
        encodeURIComponent('第' + item.phase + '期')
      this.$betterwe.jumpRoute(url)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .van-list__finished-text {
  font-size: 12px;
}

.hot {
  min-height: 100vh;
  background-color: #fff;

  .bg {
    width: 100%;
  }

  .refresh {
    min-height: 100vh;
  }

  .container {
    .list {
      padding: 0px 16px;

      .list-item {
        padding: 16px 0px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

        .item-icon {
          width: 60px;
          height: 80px;
          background: #e8e8ea;
          border-radius: 6px;
          overflow: hidden;
          margin-right: 8px;

          .icon {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .item-right {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;

          .item-title {
            word-break: break-all;
            height: 44px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.8);
            line-height: 22px;
            margin-bottom: 16px;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box; //将元素设为盒子伸缩模型显示
            -webkit-box-orient: vertical; //伸缩方向设为垂直方向
            -webkit-line-clamp: 2; //超出3行隐藏，并显示省略号
          }

          .i-r-bottom {
            display: flex;
            align-items: center;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(0, 0, 0, 0.5);
            line-height: 18px;

            .item-read {
              width: 95px;
              margin-right: 10px;
              display: flex;
              align-items: center;

              .read-icon {
                width: 16px;
                height: 16px;
                object-fit: contain;
                display: inline-block;
              }
            }

            .item-time {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .item-preview {
              display: flex;
              align-items: center;
            }
          }
        }
      }
    }
  }
}
</style>
